
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { logger } from './utils/logger';
import './index.css';
import './styles/themes.css';
// Import i18n configuration
import './i18n';
// Import registration function
import { registerSW } from 'virtual:pwa-register';
// Import storage migration
import { runStorageMigration } from './services/storageMigration';
// Flexy: Import TIME_MS for modular timeout values
import { TIME_MS, LOG_MESSAGES } from './constants';

// Run storage migration before initialization
runStorageMigration();

// Register PWA Service Worker
const updateSW = registerSW({
  onNeedRefresh() {
    window.dispatchEvent(new CustomEvent('sw-update-available'));
  },
  onOfflineReady() {
    logger.info(LOG_MESSAGES.APP.OFFLINE_READY);
  },
});

(window as typeof window & { updatePWA?: () => void }).updatePWA = () => updateSW(true);

// BroCula: Global unhandled promise rejection handler
// Prevents uncaught promise rejections from appearing in console
// Routes errors to logger for centralized error tracking
window.addEventListener('unhandledrejection', (event) => {
  event.preventDefault();
    logger.error(LOG_MESSAGES.APP.UNHANDLED_REJECTION, event.reason);
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Hide initial loader after React mounts to prevent layout shift
const hideInitialLoader = () => {
  const loader = document.getElementById('initial-loader');
  if (loader) {
    loader.style.opacity = '0';
    loader.style.transition = 'opacity 0.3s ease-out';
    setTimeout(() => {
      loader.style.display = 'none';
    }, TIME_MS.ANIMATION); // Flexy: Using centralized constant instead of magic number
  }
};

// Hide loader after a short delay to ensure React has rendered
if (document.readyState === 'complete') {
  hideInitialLoader();
} else {
  window.addEventListener('load', hideInitialLoader);
}
